const devProducts = [
  { Id: "b67e50f3-26ef-44db-93b3-95c1caeed4f3", planId: null },
  { Id: "e9898a07-480f-4d5c-a225-ce9f892f9262", planId: "P-4B203957H9013301ELZH7ZTA" },
  { Id: "e87dd6ad-e92b-4ac9-a6c9-d0c45264d00b", planId: "P-7JP30267CK150871TLZCB7FQ" },
  { Id: "6504214c-1d56-4bce-9c1a-d970e2ff4b8a", planId: "P-4XX66464EK1868332LZH7ZFI", upgrade: "P-46N05717HL045035FLZH72GI", name: "Standard", upgradeName: "Enhanced", prefix: "Upgrade" },
  { Id: "3ea632dd-43a5-40aa-8dc8-e7e6a98655d3", planId: "P-46N05717HL045035FLZH72GI", upgrade: "P-4XX66464EK1868332LZH7ZFI", name: "Enhanced", upgradeName: "Standard", prefix: "Downgrade" },
  { Id: "56015120-8757-11eb-bdc7-0a14b8f4c1fd", planId: "P-0TL22997A0978981SMBJC2LQ", upgrade: "P-81A699056T2779821MBJC24Q", name: "Monthly Access", upgradeName: "Yearly Access", prefix: "Switch" },
  { Id: "88d67314-8757-11eb-bdc7-0a14b8f4c1fd", planId: "P-81A699056T2779821MBJC24Q", upgrade: "P-0TL22997A0978981SMBJC2LQ", name: "Yearly Access", upgradeName: "Monthly Access", prefi: "Switch" },
  { Id: "d76f1119-a921-11eb-bdc7-0a14b8f4c1fd", planId: "P-8D981573908532148MCFQVAI" },
];
const stagingProducts = devProducts;
const liveProducts = [
  { Id: "b67e50f3-26ef-44db-93b3-95c1caeed4f3", planId: null },
  { Id: "e9898a07-480f-4d5c-a225-ce9f892f9262", planId: "P-8R732271RS8660227LZCCAMI" },
  { Id: "e87dd6ad-e92b-4ac9-a6c9-d0c45264d00b", planId: "P-7JP30267CK150871TLZCB7FQ" },
  { Id: "6504214c-1d56-4bce-9c1a-d970e2ff4b8a", planId: "P-5B3598743A590903TLZCB7UY", upgrade: "P-0S800892H3738500SLZCCAQY", name: "Standard", upgradeName: "Enhanced", prefix: "Upgrade" },
  { Id: "3ea632dd-43a5-40aa-8dc8-e7e6a98655d3", planId: "P-0S800892H3738500SLZCCAQY", upgrade: "P-5B3598743A590903TLZCB7UY", name: "Enhanced", upgradeName: "Standard", prefix: "Downgrade" },
  { Id: "56015120-8757-11eb-bdc7-0a14b8f4c1fd", planId: "P-0TL22997A0978981SMBJC2LQ", upgrade: "P-81A699056T2779821MBJC24Q", name: "Monthly Access", upgradeName: "Yearly Access", prefix: "Switch" },
  { Id: "88d67314-8757-11eb-bdc7-0a14b8f4c1fd", planId: "P-81A699056T2779821MBJC24Q", upgrade: "P-0TL22997A0978981SMBJC2LQ", name: "Yearly Access", upgradeName: "Monthly Access", prefix: "Switch" },
];

export default {
  GetProducts() {
    if (process.env.VUE_APP_ENV === "DEV") {
      return devProducts;
    }
    else if (process.env.VUE_APP_ENV === "STAGING") {
      return stagingProducts;
    }
    else if (process.env.VUE_APP_ENV === "PRODUCTION") {
      return liveProducts;
    }
  },
  GetProductByPlan(planId) {
    var list = null;
    if (process.env.VUE_APP_ENV === "DEV") {
      list = devProducts;
    }
    else if (process.env.VUE_APP_ENV === "STAGING") {
      list = stagingProducts;
    }
    else if (process.env.VUE_APP_ENV === "PRODUCTION") {
      list = liveProducts;
    }

    return list.filter(x => x.planId == planId)[0];
  }
}
